import { useUrlForPageId } from '../../../../../app/pages/ui/utils/useUrlForPageId';
import { PASSENGERS_PARKING_LANDING_PAGE_ID } from '../../../../../shared/api/contentful/constants';
import { useNewBookingStore } from '../../../../domain/booking/stores/useNewBookingsStore';
import { useValidationResultMemo } from './useValidationResultMemo';

export function useBookingSubmittedValidation() {
	const { booking } = useNewBookingStore();
	const redirectUrl = useUrlForPageId(PASSENGERS_PARKING_LANDING_PAGE_ID);

	return useValidationResultMemo({
		isValid: booking.isSubmitted,
		redirectUrl,
	});
}
